/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Deductible } from './deductible';
import { SpecialEquipmentAmount } from './specialEquipmentAmount';
import { Price } from './price';

/**
 * Represents a motor vehicle partial comprehensive insurance.   (german: Kfz Teilkasko)   (bipro-kraftfahrt::Fahrzeugteilversicherung)
 */
export interface PartialComprehensiveInsurance {
  /**
   * Technical discriminator for the concrete elementary product type.
   */
  productType: string;
  /**
   * Calculated prices for this product.  Currency is always euro and cent.   (german: Beitrag) (bipro-produktmodell::Beitrag)
   */
  prices?: Array<Price>;
  deductiblePartialComprehensive?: Deductible;
  specialEquipment?: SpecialEquipmentAmount;
}
export namespace PartialComprehensiveInsurance {}
